export default "__VITE_ASSET__$DmRYD_R__"